<template>
    <div>
        <b-form-group label="CIF Cliente" label-for="cif-client">
            <b-form-input v-model="clientCif" placeholder="CIF Cliente" :disabled="disabled"
                          :class="validation ? 'is-invalid': ''"/>
            <small v-if="validation" class="text-danger">
                {{ validation }}</small>
        </b-form-group>
    </div>
</template>

<script>
import {BFormGroup, BFormInput} from 'bootstrap-vue'

export default {
    components: {
        BFormGroup,
        BFormInput,
    },
    props: {
        clientCif: {
            type: String,
            default: ''
        },
        validation: {
            type: String,
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            localClientCif: this.clientCif,
        }
    },
    watch: {
        clientCif(newVal) {
            this.localClientCif = newVal
            this.$emit('update', { client_cif: this.localClientCif })
        },
    },
}
</script>
